import React from 'react';
import CrudPage from '../../components/CrudPage';
import { countryApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'id' },
  { header: 'Country Name', field: 'name' },
  { header: 'ISO2', field: 'iso2' },
  { header: 'ISO3', field: 'iso3' },
  { header: 'Dial Code', field: 'dialCode' },
];

const formFields = [
  { name: 'name', label: 'Country Name', type: 'text', required: true },
  { name: 'iso2', label: 'ISO2 Code', type: 'text', required: true },
  { name: 'iso3', label: 'ISO3 Code', type: 'text' },
  { name: 'dialCode', label: 'Dial Code', type: 'text' },
];

const CountryPage = () => (
  <CrudPage
    title="Countries"
    subtitle="Manage countries"
    api={countryApi}
    columns={columns}
    formFields={formFields}
    idField="id"
    searchField="name"
  />
);

export default CountryPage;
